import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  module: {
    id: 'portal.views.courseOverview.hero.heading.module',
    defaultMessage: 'Module',
    description: 'Module label in hero heading',
  },
  modules: {
    id: 'portal.views.courseOverview.breadcrumb.modules',
    defaultMessage: 'Modules',
    description: 'Modules label in breadcrumb',
  },
  overview: {
    id: 'portal.views.courseOverview.tab.overview',
    defaultMessage: 'Overview',
    description: 'Overview label',
  },
  inThisModule: {
    id: 'portal.views.courseOverview.inThisModule',
    defaultMessage: 'In this module, you will',
    description: 'In this module you will label',
  },
  meetYourGuides: {
    id: 'portal.views.courseOverview.meetYourGuides',
    defaultMessage: 'Meet your guides {lineBreak} for this course',
    description: 'Meet your guides for this course label',
  },
  startTheModule: {
    id: 'portal.views.courseOverview.button.startTheModule',
    defaultMessage: 'Start The Module',
    description: 'Start the module button',
  },
  moduleLabel: {
    id: 'portal.views.courseOverview.chapter.moduleLabel',
    defaultMessage: 'Module: ',
    description: 'Module label before course name in chapters',
  },
  quote: {
    id: 'portal.views.courseOverview.quote',
    defaultMessage: 'These character themes, courage, love, and hope, are pivotal for the '
      + 'transformation that workplaces and leaders need in current times and into the future.',
    description: 'Quote block text',
  },
  nextModules: {
    id: 'portal.views.courseOverview.nextModules',
    defaultMessage: 'Next Modules',
    description: 'Next modules label',
  },
  quoteAuthor: {
    id: 'portal.views.courseOverview.quoteAuthor',
    defaultMessage: 'Deborah Miremba',
    description: 'Quote author',
  },
  quoteAuthorImageAlt: {
    id: 'portal.views.courseOverview.quoteAuthor.image.alt',
    defaultMessage: 'Simbe Kadarake',
    description: 'Quote author',
  },
  fiveDayNamePart: {
    id: 'portal.views.courseOverview.fiveDayNamePart',
    defaultMessage: '5 Day',
    description: '5 Day part in course title',
  },
});

export default messages;
